/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SensorListObject } from '@app/energy-map/interfaces/sensor-list';
import { SensorMapMarkersService } from '@app/sensordaten/services/sensor-map-markers.service';
import { isEmpty, isNil } from 'lodash';

@Component({
  selector: 'app-description-sensor',
  templateUrl: './description-sensor.component.html',
  styleUrls: ['./description-sensor.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DescriptionSensorComponent implements OnInit, OnDestroy {
  @Input() sensors: any[] = [];
  @Output() navigatedOut = new EventEmitter();
  sensorList: SensorListObject[] = [];
  sensorAddress = '';
  showBackButton = false;

  constructor(private iotSensorMarkerService: SensorMapMarkersService, private route: ActivatedRoute, private router: Router) {}

  public ngOnInit(): void {
    this.checkState();
    this.sensorList = this.sensors.map((ss) => {
      return {
        alarmRuleEnabled: ss.alarmRuleEnabled,
        device_eui: ss.device_eui,
        device_id: ss.device_id,
        device_name: ss.device_name,
        locationContext: ss.locationContext,
        sensor_id: ss.sensor_id,
        sensor_type: ss.sensor_type,
        currentQuality: ss.currentQuality,
        ruleJSON: ss.ruleJSON,
        reading: ss.reading,
      };
    });

    const s = this.sensors[0];
    this.sensorAddress = isNil(s.buildingID) || isEmpty(s.buildingID) ? '' : s.address;
  }

  public ngOnDestroy(): void {
    this.sensors = [];
    this.navigatedOut.emit(true);
  }

  public onBackButtonClicked(): void {
    this.router.navigateByUrl(this.iotSensorMarkerService.returnRoute);
  }

  private checkState(): void {
    const state = this.route.snapshot.queryParamMap.get('forcediot');
    this.showBackButton = state === 'true';
  }
}
